import { render, staticRenderFns } from "./PolizasRMSImportView.vue?vue&type=template&id=93e352c4&"
import script from "./PolizasRMSImportView.vue?vue&type=script&lang=js&"
export * from "./PolizasRMSImportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports